import React from "react";
import {
  Route,
  Redirect
} from "react-router-dom";
import PublicLayout from "./publicLayout";
import { storageHelper } from "../../lib";
import { useAppContext } from "../../lib/context";

export default function PublicContainer(props) {
  const [{user}] = useAppContext();

  const {component: Component, ...rest } = props;
  if (user && user.email) storageHelper.remove("route")
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(routeProps) => {
        return storageHelper.get("refreshToken") ? (
          <Redirect
            to={{
              pathname: (!user && user.email && "/edit-profile")  || "/",
              state: { from: routeProps.location },
            }}
          />
        ) : (
         <PublicLayout component={Component} {...routeProps} />
        );
      }}
    />
  )
}